import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DatePipe } from '@angular/common';
import { LicensesService } from '../../services/licenses/licenses.service'; // Assegura't de canviar o crear aquest servei
import * as moment from 'moment';

export interface ILicense {
  plate: string;
  name: string;
  number: string;
  type: string;
  issue_date: string;
  expiry_date: string;
  id_owner: string;
}

@Component({
  selector: 'dialog-licenses-data',
  templateUrl: './dialog.component.lic.html',
  styleUrls: ['./dialog.component.lic.scss'],
  providers: [DatePipe, LicensesService]
})
export class DialogLicenses implements OnInit {
  
  public error: string = '';
  public dia: string = null;
  public showAsyncProgress: boolean = false;
  public editLicenseData: ILicense;
  
  // Llistes per als 4 autocomplets requerits
  public plateList: any[] = [];
  public ownerList: any[] = [];
  public numberList: any[] = [];
  public typeList: any[] = [];
  
  public userInfo: any = {};

  constructor(
    private datePipe: DatePipe, 
    public dialogRef: MatDialogRef<DialogLicenses>, 
    @Inject(MAT_DIALOG_DATA) public data: any, 
    public licService: LicensesService
  ) { 
    this.editLicenseData = data.dades;
    
    // Carrega dels 4 autocomplets sol·licitats
    this.licService.getAutocomplete("plate").subscribe(result => { this.plateList = result; });
    this.licService.getAutocomplete("id_owner").subscribe(result => { this.ownerList = result; });
    this.licService.getAutocomplete("number").subscribe(result => { this.numberList = result; });
    this.licService.getAutocomplete("lic_type").subscribe(result => { this.typeList = result; });
   
    if (!this.dia) this.dia = moment().format("YYYY-MM-DD");
    this.userInfo = data.user;
  }

  onNoClick(): void {
    this.dialogRef.close(null);
  }

  desar(): void {
    this.dialogRef.close(this.editLicenseData);
  }

  close(): void {
    this.dialogRef.close(null);
  }

  ngOnInit() { }
}